<div id="content-desktop">
  <div class="container" style="border:1px solid #bebaba">
    <div class="row text-center background-bottom">
      <br />
      <div class="row">
        <div class="col-md-12" style="font-weight:bold">
          This official website is maintained by the Claims Administrator under the supervision of Class Counsel for the members of the Settlement Class
          in <i>Burke v. Visa Inc</i>., Case No. 1:11-cv-01882 (D.D.C.), which is pending in the United States District Court for the District of Columbia.
          <br />

          <h2 style="color: darkblue; font-weight:bold">
            Non Bank ATM Surcharge Settlement
          </h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 Background1">
        <a [routerLink]="['/file']"></a>
      </div>
    </div>
    <br />
    <br />
    <div class="row" style="margin-left:5%;margin-right:5%">
      <div class="col-md-12" style="text-align:justify; text-justify:distribute-all-lines; font-weight:bold">
        The information contained on this web page is only a summary of information presented in more
        detail in the Settlement Notice, which you can access by clicking <a href="../../../assets/documents/Burke v. Visa_Long Form Notice_FINAL.pdf" target="_blank">here</a>. Since this website is just a
        summary, you should review the Settlement Notice for additional information.<br /><br />

        This website also contains links to case documents, important deadlines, and the Settlement
        Agreement which are available <a [routerLink]="['/court-documents']">here</a> for you to review.<br /><br />

        If you are a Settlement Class Member, your legal rights will be affected by this Settlement whether
        you act or do not act.
      </div>
    </div>
    <br />
    <h2 style="color: darkblue; font-weight:bold; text-align:center">
      Please read the Settlement Notice carefully.
    </h2>
    <br />
    <div class="row" style="margin-left:5%;margin-right:5%">
      <div class="col-md-12" style="text-align:justify; text-justify:distribute-all-lines;">
        <p style="font-size:1.0em">
          <ul>
            <li>
              There is a proposed Settlement in a class action lawsuit that says Visa Inc., Visa U.S.A. Inc., Visa
              International Service Association, Plus System, Inc. (“Visa”) and Mastercard Incorporated and Mastercard
              International Incorporated d/b/a Mastercard Worldwide (“Mastercard”) network operating rules violated
              antitrust laws by prohibiting independent automated teller machine (“IATM”) operators from charging
              differential ATM surcharges (also called access fees). IATM operators were not allowed to “discount”
              or charge cardholders a lower access fee if transactions could be processed on competing networks that
              cost less than the Visa or Mastercard networks. Therefore, cardholders paid higher access fees to use
              IATMs than they should have. Visa and Mastercard deny they did anything wrong.
            </li>
            <li>
              Generally, you are included in the Settlement as part of the Nationwide Class if you are in the United
              States, were charged a surcharge (or access fee) to withdraw cash from your deposit account using an
              ATM or pin-debit card at an independent ATM (an ATM not owned by a bank or financial institution)
              located in the United States (including its territories). You may also be included as part of the
              Statewide Classes for California, Illinois, Massachusetts, and Michigan. You may be able to get
              money from this Settlement if your cash withdrawal transactions were made between October 24,
              2007, and August 14, 2026, and were not fully reimbursed by your bank.

            </li>
            <li>
              The $167.5 million Settlement Fund will pay (1) attorneys’ fees, costs, and expenses; (2) notice
              and administration costs; (3) taxes and tax expenses; (4) service awards to the class representatives;
              and (5) money to eligible Class Members.

            </li>
            <li>
              Please carefully read this Notice and the Settlement Agreement available
              <a [routerLink]="['/court-documents']">here</a>. Your legal rights may be affected whether you act or do not act.
            </li>
          </ul>


          <br />
      </div>
    </div>
    <div class="row background-yellow-banner text-center">
      <div class="col-md-12">
        <h2 style="color: white; font-weight:bold; text-align:center">
          SUBMIT A CLAIM FORM
        </h2>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-6">

        <img src="../../../assets/File Now.png" class="img-responsive" style="width:100%;  display: block; margin: 0 auto; width: 40%;">
        <a [routerLink]="['/file']"></a>
      </div>
      <div class="col-md-6">
        <b>
          To receive a payment, you must complete and timely
          submit a valid Claim Form by February 10, 2027.
        </b>
        You may complete and submit an electronic Claim
        Form online <a [routerLink]="['/file']">here</a>
        or by calling 1-866-893-1052
        <br />

        <a [routerLink]="['/file']">

          <img src="../../../assets/CTA button.png" class="img-responsive" style="width:100%; float: left; display: block; margin: 0 auto; width: 50%;">
        </a>
      </div>
    </div>
    <div class="row">
      <br />
    </div>
    <br />
    <div class="row background-green-banner text-center">
      <div class="col-md-12">
        <h2 style=" font-weight:bold; text-align:center">
          YOUR LEGAL RIGHTS AND OPTIONS<br />
          IN THIS SETTLEMENT
        </h2>
      </div>
    </div>
    <br />
    <div class="row" style="margin-left:5%;margin-right:5%; margin-top:3%">
      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table table-bordered">
            <tbody>
              <tr>
                <td style=" background-color: lightgray; text-align: center; font-weight: bold;vertical-align: middle; width: 25%">
                  SUBMIT A CLAIM FORM
                </td>
                <td style="background-color:white; color:#3e4144; width:75%">
                  You must submit a valid claim form to get a payment in this Settlement no later than <b>February 10, 2027</b>.
                </td>

              </tr>
              <tr>
                <td style=" background-color: lightgray; text-align: center; font-weight: bold;vertical-align: middle; width: 25%">
                  EXCLUDE YOURSELF
                </td>
                <td style="background-color:white; color:#3e4144; width:75%">
                  This is the only option that allows you to sue Visa or Mastercard on your own, or as part of any other lawsuit,
                  for the claims in this case. If you exclude yourself, you will not be eligible to get a payment from the Settlement.
                  You can exclude yourself from the Settlement by mailing a letter, so that it is <b>
                    received no later than December 11,
                    2026
                  </b>, to the Claims Administrator saying you want to opt out. See Question 18 in the
                  <a href="../../../assets/documents/Burke v. Visa_Long Form Notice_FINAL.pdf" target="_blank">Settlement Notice</a>.
                </td>
              <tr>
                <td style=" background-color:lightgray; text-align:center; font-weight:bold;  vertical-align: middle; width:25%">
                  OBJECT
                </td>
                <td style="background-color:white; color:#3e4144; width:75%">
                  You can write the Court about why you like or do not like the Settlement. Your objection must be <b>
                    postmarked no
                    later than December 11, 2026
                  </b>. See Question 23 in the <a href="../../../assets/documents/Burke v. Visa_Long Form Notice_FINAL.pdf" target="_blank">Settlement Notice</a>.
                </td>

              </tr>
              <tr>
                <td style=" background-color: lightgray; text-align: center; font-weight: bold;vertical-align: middle; width: 25%">
                  ATTEND THE
                  HEARING
                </td>
                <td style="background-color:white; color:#3e4144; width:75%">
                  You can also ask to speak to the Court at the hearing about the fairness of the Settlement, with or without your own
                  attorney. The Fairness Hearing is set for <b>February 17, 2027 at 4 p.m. ET</b>. See Question 29 in the
                  <a href="../../../assets/documents/Burke v. Visa_Long Form Notice_FINAL.pdf" target="_blank">Settlement Notice</a>.
                </td>

              </tr>
              <tr>
                <td style=" background-color: lightgray; text-align: center; font-weight: bold;vertical-align: middle; width: 25%">
                  DO NOTHING
                </td>
                <td style="background-color:white; color:#3e4144; width:75%">
                  If you do nothing, you will not get any money from this Settlement. You will also give
                  up your legal right to sue Visa and Mastercard for the claims in this case.
                </td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <br />
    <br />
    <div class="row text-center">
      <div class="col-md-12">
        <img src="../assets/People graphic.png" class="img-responsive" style="width:100%; display: block; margin: 0 auto; width: 50%;">
      </div>
    </div>
    <div class="panel-heading" style="background-color: #8BC34A; color: black; text-align: center; font-weight: bold">

      <div class="col-md-12">
        <br />

        <p style="text-align:center; font-weight:bold">
          If you have questions or want more information,<br />
          you may call or you may contact the Claims Administrator by email, or by writing to:<br />
          Non-Bank ATM Surcharge Fee Settlement<br />
          c/o A.B. Data, Ltd.<br />
          PO Box 173053<br />
          Milwaukee, WI 53217<br />
          Toll Free: 1-866-893-1053<br />
          Email: <a href="mailto:info@NonBankATMSurchargeSettlement.com">info@NonBankATMSurchargeSettlement.com</a><br /><br />

          PLEASE DO NOT CALL OR WRITE TO THE COURT OR THE CLERK’S OFFICE FOR INFORMATION.<br />
          THE COURT CANNOT ANSWER ANY QUESTIONS.<br />
        </p>
        <br />
      </div>
    </div>

  </div>
  <br />
  <br />
</div>




<div id="content-mobile">
  <div class="container" style="border:1px solid #bebaba">
    <div class="row text-center background-bottom">
      <br />
      <div class="row">
        <div class="col-md-12" style="font-weight:bold">
          This official website is maintained by the Claims Administrator under the supervision of Class Counsel for the members of the Settlement Class
          in <i>Burke v. Visa Inc</i>., Case No. 1:11-cv-01882 (D.D.C.), which is pending in the United States District Court for the District of Columbia.
          <br />

          <h2 style="color: darkblue; font-weight:bold">
            Non Bank ATM Surcharge Settlement
          </h2>
        </div>
      </div>
    </div>
    <div class="row" style="margin-left:5%;margin-right:5%">
      <div class="col-md-12" style="text-align:justify; text-justify:distribute-all-lines; font-weight:bold">
        <div class="Background1">
          <a [routerLink]="['/file']"></a>
        </div>
        The information contained on this web page is only a summary of information presented in more
        detail in the Settlement Notice, which you can access by clicking <a href="../../../assets/documents/Burke v. Visa_Long Form Notice_FINAL.pdf" target="_blank">here</a>. Since this website is just a
        summary, you should review the Settlement Notice for additional information.<br /><br />

        This website also contains links to case documents, important deadlines, and the Settlement
        Agreement which are available <a [routerLink]="['/court-documents']">here</a> for you to review.<br /><br />

        If you are a Settlement Class Member, your legal rights will be affected by this Settlement whether
        you act or do not act.
      </div>
    </div>
    <br />
    <h2 style="color: darkblue; font-weight:bold; text-align:center">
      Please read the Settlement Notice carefully.
    </h2>
    <br />
    <div class="row" style="margin-left:5%;margin-right:5%">
      <div class="col-md-12" style="text-align:justify; text-justify:distribute-all-lines;">
        <p style="font-size:1.0em">
          <ul>
            <li>
              There is a proposed Settlement in a class action lawsuit that says Visa Inc., Visa U.S.A. Inc., Visa
              International Service Association, Plus System, Inc. (“Visa”) and Mastercard Incorporated and Mastercard
              International Incorporated d/b/a Mastercard Worldwide (“Mastercard”) network operating rules violated
              antitrust laws by prohibiting independent automated teller machine (“IATM”) operators from charging
              differential ATM surcharges (also called access fees). IATM operators were not allowed to “discount”
              or charge cardholders a lower access fee if transactions could be processed on competing networks that
              cost less than the Visa or Mastercard networks. Therefore, cardholders paid higher access fees to use
              IATMs than they should have. Visa and Mastercard deny they did anything wrong.
            </li>
            <li>
              Generally, you are included in the Settlement as part of the Nationwide Class if you are in the United
              States, were charged a surcharge (or access fee) to withdraw cash from your deposit account using an
              ATM or pin-debit card at an independent ATM (an ATM not owned by a bank or financial institution)
              located in the United States (including its territories). You may also be included as part of the
              Statewide Classes for California, Illinois, Massachusetts, and Michigan. You may be able to get
              money from this Settlement if your cash withdrawal transactions were made between October 24,
              2007, and August 14, 2026, and were not fully reimbursed by your bank.

            </li>
            <li>
              The $167.5 million Settlement Fund will pay (1) attorneys’ fees, costs, and expenses; (2) notice
              and administration costs; (3) taxes and tax expenses; (4) service awards to the class representatives;
              and (5) money to eligible Class Members.

            </li>
            <li>
              Please carefully read this Notice and the Settlement Agreement available
              <a [routerLink]="['/court-documents']">here</a>. Your legal rights may be affected whether you act or do not act.
            </li>
          </ul>


          <br />
      </div>
    </div>
    <div class="row background-yellow-banner text-center">
      <div class="col-md-12">
        <h2 style="color: white; font-weight:bold; text-align:center">
          SUBMIT A CLAIM FORM
        </h2>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-6">

        <img src="../../../assets/File Now.png" class="img-responsive" style="width:100%;  display: block; margin: 0 auto; width: 40%;">
        <a [routerLink]="['/file']"></a>
      </div>
      <div class="col-md-6">
        <b>
          To receive a payment, you must complete and timely
          submit a valid Claim Form by February 10, 2027.
        </b>
        You may complete and submit an electronic Claim
        Form online <a [routerLink]="['/file']">here</a>
        or by calling 1-866-893-1052
        <br />

        <a [routerLink]="['/file']">

          <img src="../../../assets/CTA button.png" class="img-responsive" style="width:100%; float: left; display: block; margin: 0 auto; width: 50%;">
        </a>
      </div>
    </div>
    <div class="row">
      <br />
    </div>
    <br />
    <div class="row background-green-banner text-center">
      <div class="col-md-12">
        <h2 style=" font-weight:bold; text-align:center">
          YOUR LEGAL RIGHTS AND OPTIONS<br />
          IN THIS SETTLEMENT
        </h2>
      </div>
    </div>
    <br />
    <div class="row" style="margin-left:5%;margin-right:5%; margin-top:3%">
      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table table-bordered">
            <tbody>
              <tr>
                <td style=" background-color: lightgray; text-align: center; font-weight: bold;vertical-align: middle; width: 25%">
                  SUBMIT A CLAIM FORM
                </td>
                <td style="background-color:white; color:#3e4144; width:75%">
                  You must submit a valid claim form to get a payment in this Settlement no later than <b>February 10, 2027</b>.
                </td>

              </tr>
              <tr>
                <td style=" background-color: lightgray; text-align: center; font-weight: bold;vertical-align: middle; width: 25%">
                  EXCLUDE YOURSELF
                </td>
                <td style="background-color:white; color:#3e4144; width:75%">
                  This is the only option that allows you to sue Visa or Mastercard on your own, or as part of any other lawsuit,
                  for the claims in this case. If you exclude yourself, you will not be eligible to get a payment from the Settlement.
                  You can exclude yourself from the Settlement by mailing a letter, so that it is <b>
                    received no later than December 11,
                    2026
                  </b>, to the Claims Administrator saying you want to opt out. See Question 18 in the
                  <a href="../../../assets/documents/Burke v. Visa_Long Form Notice_FINAL.pdf" target="_blank">Settlement Notice</a>.
                </td>
              <tr>
                <td style=" background-color:lightgray; text-align:center; font-weight:bold;  vertical-align: middle; width:25%">
                  OBJECT
                </td>
                <td style="background-color:white; color:#3e4144; width:75%">
                  You can write the Court about why you like or do not like the Settlement. Your objection must be <b>
                    postmarked no
                    later than December 11, 2026
                  </b>. See Question 23 in the <a href="../../../assets/documents/Burke v. Visa_Long Form Notice_FINAL.pdf" target="_blank">Settlement Notice</a>.
                </td>

              </tr>
              <tr>
                <td style=" background-color: lightgray; text-align: center; font-weight: bold;vertical-align: middle; width: 25%">
                  ATTEND THE
                  HEARING
                </td>
                <td style="background-color:white; color:#3e4144; width:75%">
                  You can also ask to speak to the Court at the hearing about the fairness of the Settlement, with or without your own
                  attorney. The Fairness Hearing is set for <b>February 17, 2027 at 4 p.m. ET</b>. See Question 29 in the
                  <a href="../../../assets/documents/Burke v. Visa_Long Form Notice_FINAL.pdf" target="_blank">Settlement Notice</a>.
                </td>

              </tr>
              <tr>
                <td style=" background-color: lightgray; text-align: center; font-weight: bold;vertical-align: middle; width: 25%">
                  DO NOTHING
                </td>
                <td style="background-color:white; color:#3e4144; width:75%">
                  If you do nothing, you will not get any money from this Settlement. You will also give
                  up your legal right to sue Visa and Mastercard for the claims in this case.
                </td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <br />
    <br />
    <div class="row text-center">
      <div class="col-md-12">
        <img src="../assets/People graphic.png" class="img-responsive" style="width:100%; display: block; margin: 0 auto; width: 50%;">
      </div>
    </div>
    <div class="panel-heading" style="background-color: #8BC34A; color: black; text-align: center; font-weight: bold">

      <div class="col-md-12">
        <br />

        <p style="text-align:center; font-weight:bold">
          If you have questions or want more information,<br />
          you may call or you may contact the Claims Administrator by email, or by writing to:<br />
          Non-Bank ATM Surcharge Fee Settlement<br />
          c/o A.B. Data, Ltd.<br />
          PO Box 173053<br />
          Milwaukee, WI 53217<br />
          Toll Free: 1-866-893-1053<br />
          Email: <a href="mailto:info@NonBankATMSurchargeSettlement.com">info@NonBankATMSurchargeSettlement.com</a><br /><br />

          PLEASE DO NOT CALL OR WRITE TO THE COURT OR THE CLERK’S OFFICE FOR INFORMATION.<br />
          THE COURT CANNOT ANSWER ANY QUESTIONS.<br />
        </p>
        <br />
      </div>
    </div>

  </div>
  <br />
  <br />
</div>
